import {useEffect, useRef, useState} from "react";
import "./TeamSection.css";
import "./TeamBlobs.css";
import {MainBackground} from "../../../assets/svg/our-team/backgrounds/main-imgs";
import {ReactComponent as ArrowLeftWave} from "../../../assets/svg/our-team/backgrounds/arrows-wave/arrow-left.svg";
import {ReactComponent as ArrowRightWave} from "../../../assets/svg/our-team/backgrounds/arrows-wave/arrow-right.svg";

// Тестовий inline-SVG варіант тих самих 9 колірних груп (замість
// border-image-source, щоб перевірити, чи прийнятне спотворення кутів
// при preserveAspectRatio="none" на змінній ширині nameTag/quoteTag —
// див. обговорення в чаті).
import {ReactComponent as TagFrameMember1Light} from "../../../assets/svg/our-team/tag-frame/member1-light.svg";
import {ReactComponent as TagFrameMember1Dark} from "../../../assets/svg/our-team/tag-frame/member1-dark.svg";
import {ReactComponent as TagFrameMember2Light} from "../../../assets/svg/our-team/tag-frame/member2-light.svg";
import {ReactComponent as TagFrameMember2Dark} from "../../../assets/svg/our-team/tag-frame/member2-dark.svg";
import {ReactComponent as TagFrameMember3Light} from "../../../assets/svg/our-team/tag-frame/member3-light.svg";
import {ReactComponent as TagFrameMember3Dark} from "../../../assets/svg/our-team/tag-frame/member3-dark.svg";
import {ReactComponent as TagFrameMember4Light} from "../../../assets/svg/our-team/tag-frame/member4-light.svg";
import {ReactComponent as TagFrameMember4Dark} from "../../../assets/svg/our-team/tag-frame/member4-dark.svg";
import {ReactComponent as TagFrameMember5Light} from "../../../assets/svg/our-team/tag-frame/member5-light.svg";
import {ReactComponent as TagFrameMember5Dark} from "../../../assets/svg/our-team/tag-frame/member5-dark.svg";
import {ReactComponent as TagFrameMember6Light} from "../../../assets/svg/our-team/tag-frame/member6-light.svg";
import {ReactComponent as TagFrameMember6Dark} from "../../../assets/svg/our-team/tag-frame/member6-dark.svg";
import {ReactComponent as TagFrameMember7Light} from "../../../assets/svg/our-team/tag-frame/member7-light.svg";
import {ReactComponent as TagFrameMember7Dark} from "../../../assets/svg/our-team/tag-frame/member7-dark.svg";
import {ReactComponent as TagFrameMember11Light} from "../../../assets/svg/our-team/tag-frame/member11-light.svg";
import {ReactComponent as TagFrameMember11Dark} from "../../../assets/svg/our-team/tag-frame/member11-dark.svg";
import {ReactComponent as TagFrameMember15Light} from "../../../assets/svg/our-team/tag-frame/member15-light.svg";
import {ReactComponent as TagFrameMember15Dark} from "../../../assets/svg/our-team/tag-frame/member15-dark.svg";

// Тестовий inline-SVG варіант тих самих 9 колірних груп для рамки активної
// клітинкиグрід (той самий підхід, що й TAG_FRAME_COMPONENTS вище). Тут
// клітинка завжди квадратна на кожному брейкпойнті (136→104→78→60→48→40px),
// тож preserveAspectRatio="none" не має що спотворювати -- аспект джерела
// й цілі однакові на кожному розмірі.
import {
  ReactComponent as GridFrameMember1Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member1-light.svg";
import {
  ReactComponent as GridFrameMember1Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member1-dark.svg";
import {
  ReactComponent as GridFrameMember2Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member2-light.svg";
import {
  ReactComponent as GridFrameMember2Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member2-dark.svg";
import {
  ReactComponent as GridFrameMember3Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member3-light.svg";
import {
  ReactComponent as GridFrameMember3Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member3-dark.svg";
import {
  ReactComponent as GridFrameMember4Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member4-light.svg";
import {
  ReactComponent as GridFrameMember4Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member4-dark.svg";
import {
  ReactComponent as GridFrameMember5Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member5-light.svg";
import {
  ReactComponent as GridFrameMember5Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member5-dark.svg";
import {
  ReactComponent as GridFrameMember6Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member6-light.svg";
import {
  ReactComponent as GridFrameMember6Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member6-dark.svg";
import {
  ReactComponent as GridFrameMember7Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member7-light.svg";
import {
  ReactComponent as GridFrameMember7Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member7-dark.svg";
import {
  ReactComponent as GridFrameMember11Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member11-light.svg";
import {
  ReactComponent as GridFrameMember11Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member11-dark.svg";
import {
  ReactComponent as GridFrameMember15Light
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member15-light.svg";
import {
  ReactComponent as GridFrameMember15Dark
} from "../../../assets/svg/our-team/tag-frame/grid-frame-member15-dark.svg";

import imgMember1 from "../../../assets/team-img/photo-1.png";
import imgMember2 from "../../../assets/team-img/photo-2.png";
import imgMember3 from "../../../assets/team-img/photo-3.png";
import imgMember4 from "../../../assets/team-img/photo-4.png";
import imgMember5 from "../../../assets/team-img/photo-5.png";
import imgMember6 from "../../../assets/team-img/photo-6.png";
import imgMember7 from "../../../assets/team-img/photo-7.png";
import imgMember8 from "../../../assets/team-img/photo-8.png";
import imgMember9 from "../../../assets/team-img/photo-9.png";
import imgMember10 from "../../../assets/team-img/photo-10.png";
import imgMember11 from "../../../assets/team-img/photo-11.png";
import imgMember12 from "../../../assets/team-img/photo-12.png";
import imgMember13 from "../../../assets/team-img/photo-13.png";
import imgMember14 from "../../../assets/team-img/photo-14.png";
import imgMember15 from "../../../assets/team-img/photo-15.png";
import imgMember16 from "../../../assets/team-img/photo-16.png";
import imgMember17 from "../../../assets/team-img/photo-17.png";

const AUTO_ROTATE_MS = 7000; // 7000

const TAG_FRAME_COMPONENTS = {
  member1: {Light: TagFrameMember1Light, Dark: TagFrameMember1Dark},
  member2: {Light: TagFrameMember2Light, Dark: TagFrameMember2Dark},
  member3: {Light: TagFrameMember3Light, Dark: TagFrameMember3Dark},
  member4: {Light: TagFrameMember4Light, Dark: TagFrameMember4Dark},
  member5: {Light: TagFrameMember5Light, Dark: TagFrameMember5Dark},
  member6: {Light: TagFrameMember6Light, Dark: TagFrameMember6Dark},
  member7: {Light: TagFrameMember7Light, Dark: TagFrameMember7Dark},
  member11: {Light: TagFrameMember11Light, Dark: TagFrameMember11Dark},
  member15: {Light: TagFrameMember15Light, Dark: TagFrameMember15Dark},
};

const GRID_FRAME_COMPONENTS = {
  member1: {Light: GridFrameMember1Light, Dark: GridFrameMember1Dark},
  member2: {Light: GridFrameMember2Light, Dark: GridFrameMember2Dark},
  member3: {Light: GridFrameMember3Light, Dark: GridFrameMember3Dark},
  member4: {Light: GridFrameMember4Light, Dark: GridFrameMember4Dark},
  member5: {Light: GridFrameMember5Light, Dark: GridFrameMember5Dark},
  member6: {Light: GridFrameMember6Light, Dark: GridFrameMember6Dark},
  member7: {Light: GridFrameMember7Light, Dark: GridFrameMember7Dark},
  member11: {Light: GridFrameMember11Light, Dark: GridFrameMember11Dark},
  member15: {Light: GridFrameMember15Light, Dark: GridFrameMember15Dark},
};

const FRAME_GROUP = {
  member1: "member1", member8: "member1", member2: "member2", member12: "member2",
  member3: "member3", member13: "member3", member4: "member4", member16: "member4",
  member5: "member5", member9: "member5", member6: "member6", member10: "member6",
  member7: "member7", member14: "member7", member11: "member11", member17: "member11",
  member15: "member15",
};

// Order matches the Figma mockup (pages -> full -> "Our team" grid, left to right, top to bottom).
const MEMBERS = [
  {
    img: imgMember1,
    name: "Kostiantyn",
    role: "CEO",
    quote: "The spark of enthusiasm and ambition 💡",
    blob: "member1"
  },
  {
    img: imgMember2,
    name: "Natali",
    role: "COO",
    quote: "Turns plans into completed projects ✨",
    blob: "member2"
  },
  {
    img: imgMember3,
    name: "Oleksandra",
    role: "Business Development Manager",
    quote: "Performance with a personal touch 🦄",
    blob: "member3"
  },
  {
    img: imgMember4,
    name: "Tetiana",
    role: "Business Development Manager",
    quote: "Driving force behind every deal 💰",
    blob: "member4"
  },
  {
    img: imgMember17,
    name: "Anna",
    role: "Finance Manager",
    quote: "Counting on growth — literally 💸",
    blob: "member17"
  },
  {
    img: imgMember5,
    name: "Vladislav",
    role: "PM",
    quote: "Turns \"Who was supposed to do that?\" into \"Already done\" ⚡",
    blob: "member5"
  },
  {
    img: imgMember6,
    name: "Dmytro",
    role: "CTO",
    quote: "Speaks both human and machine fluently 🦾",
    blob: "member6"
  },
  {
    img: imgMember7,
    name: "Ievgen",
    role: "Back-end Developer",
    quote: "Confidently runs the show on back-end 🎛️",
    blob: "member7"
  },
  {
    img: imgMember8,
    name: "Vasyl",
    role: "Full-stack Developer",
    quote: "Knows every layer of the stack — and how they talk 🧠",
    blob: "member8"
  },
  {
    img: imgMember9,
    name: "Svetlana",
    role: "Full-stack Developer",
    quote: "Turns 10 spreadsheets and 5 chats into one clean platform 📊",
    blob: "member9"
  },
  {
    img: imgMember10,
    name: "Daria",
    role: "QA",
    quote: "Has a ghost trap for the bugs haunting the code 👻",
    blob: "member10"
  },
  {
    img: imgMember11,
    name: "Daria",
    role: "UI/UX Designer",
    quote: "Spots a misaligned pixel from across the room 🎨",
    blob: "member11"
  },
  {
    img: imgMember12,
    name: "Anastasiia",
    role: "Chief Analyst",
    quote: "Finds meaning where others see only metrics 🔍",
    blob: "member12"
  },
  {
    img: imgMember16,
    name: "Yuliia",
    role: "Statist/Analyst",
    quote: "Reads between the data lines 📚",
    blob: "member16"
  },
  {
    img: imgMember13,
    name: "Oleksandra",
    role: "HRD",
    quote: "Keeps the human in Human Resources 💖",
    blob: "member13"
  },
  {
    img: imgMember14,
    name: "Alyona",
    role: "HR Manager",
    quote: "Knows how the team feels, not just how it performs 💞",
    blob: "member14"
  },
  {
    img: imgMember15,
    name: "Anna",
    role: "SMM Manager",
    quote: "Makes content that stops thumbs and starts conversations 📱",
    blob: "member15"
  },
];

export function TeamSlider() {
  const [activeIdx, setActiveIdx] = useState(0);
  const timerRef = useRef(null);
  const member = MEMBERS[activeIdx];
  const BlobBg = MainBackground;
  // const tagFrame = TAG_FRAMES[FRAME_GROUP[member.blob]];
  const {Light: TagFrameLight, Dark: TagFrameDark} = TAG_FRAME_COMPONENTS[FRAME_GROUP[member.blob]];

  const restartTimer = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setActiveIdx((i) => (i + 1) % MEMBERS.length);
    }, AUTO_ROTATE_MS);
  };

  useEffect(() => {
    restartTimer();
    return () => clearInterval(timerRef.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goTo = (idx) => {
    setActiveIdx(idx);
    restartTimer();
  };

  return (
    <div className="team-slider-wrapper">

      {/* FEATURED CARD */}
      <div className="featuredCardWrap">
        <div className="featuredCard">

          <ArrowLeftWave key={`wave-left-${activeIdx}`}
                         className={`waveArrow waveArrow--left blob-${member.blob}`}
                         aria-hidden="true"/>
          <ArrowRightWave key={`wave-right-${activeIdx}`}
                          className={`waveArrow waveArrow--right blob-${member.blob}`}
                          aria-hidden="true"/>

          <div key={activeIdx} className={`blobPhoto blob-${member.blob}`}>
            <BlobBg className="blobSvg" aria-hidden="true"/>
            <img className={`blobImg blobImg-${member.blob}`} src={member.img} alt={member.name}/>
          </div>

          {/* Per the mockup, the lower loop of the right wave passes in front of
              the photo before going back behind it — same asset, clipped to just
              that crossing sliver and stacked above .blobPhoto. */}
          <ArrowRightWave key={`wave-right-front-${activeIdx}`}
                          className={`waveArrow waveArrow--right waveArrow--right-front blob-${member.blob}`}
                          aria-hidden="true"
          />

          <div
            key={`tag-${activeIdx}`}
            className={`nameTag blob-${member.blob}`}
          >
            <TagFrameLight className="tagFrame-bg tagFrame-bg-light" preserveAspectRatio="none"
                           aria-hidden="true" focusable="false"/>
            <TagFrameDark className="tagFrame-bg tagFrame-bg-dark" preserveAspectRatio="none"
                          aria-hidden="true" focusable="false"/>

            <p className="nameTagName">{member.name}</p>
            <p className="nameTagRole">{member.role}</p>

            {member.quote && (
              <div key={`quote-${activeIdx}`} className="quoteTag">
                <TagFrameLight className="tagFrame-bg tagFrame-bg-light" preserveAspectRatio="none"
                               aria-hidden="true" focusable="false"/>
                <TagFrameDark className="tagFrame-bg tagFrame-bg-dark" preserveAspectRatio="none"
                              aria-hidden="true" focusable="false"/>
                <p>"{member.quote.replace(/ (?=\S+$)/, "\u00A0")}"</p>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* MINIATURE GRID */}
      <div className="teamGrid">
        {MEMBERS.map((m, i) => {
          // const gridFrame = GRID_FRAMES[FRAME_GROUP[m.blob]];
          const {Light: GridFrameLight, Dark: GridFrameDark} = GRID_FRAME_COMPONENTS[FRAME_GROUP[m.blob]];
          return (
            <button
              key={i}
              className={`memberThumb blob-${m.blob} ${i === activeIdx ? "active" : ""}`}
              onClick={() => goTo(i)}
            >
              <GridFrameLight className="gridFrame-bg gridFrame-bg-light" preserveAspectRatio="none"
                              aria-hidden="true" focusable="false"/>
              <GridFrameDark className="gridFrame-bg gridFrame-bg-dark" preserveAspectRatio="none"
                             aria-hidden="true" focusable="false"/>
              <img className={`thumbImg thumbImg-${m.blob}`} src={m.img} alt={m.name}/>
            </button>
          );
        })}
      </div>
    </div>
  );
}
